module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/about/about.component.scss
// module id = ./src/app/pages/about/about.component.scss
// module chunks = main